import React, { useContext } from 'react';
import { TableDataContext } from '../../Contexts/TableDataContext'
import TextCard from './TextCard';
import tfs_Icon from '../../images/Shape_4/png/Shape.png';
import companyIcon from '../../images/noun-investment-2180740_5/png/noun-investment-2180740.png';
import tfIn_Icon from '../../images/noun-investment-2180740_2/png/noun-investment-2180740.png';
import pe_Icon from '../../images/noun-investment-2180740_4/png/noun-investment-2180740.png';
import { checkValue } from '../../Utils/utils';


/**
 * The `IpoCard` component renders a set of `TextCard` components displaying IPO-related data fetched
 * from a context.
 * @returns The IpoCard component is returning a JSX element.
 */
const IpoCard = () => {
    const { data, isLoad, isDataLoad } = useContext(TableDataContext);
    return (
        <div className="">
            <div className='sm:full md:mt-[3rem] mt-[4.25rem] h-full bg-[#F2F2F2]'>
                <div className="hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden" style={{scrollbarWidth: 'none'}}>
                    <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:py-[0.7rem] md:min-w-max lg:contents">
                    <TextCard
                        image={companyIcon}
                        isLoading={isDataLoad}
                        showCount={true}
                        subtitle={checkValue(data?.amount_usd)}
                        title={"Total IPO Size in (US$ M)"}
                    />
                    <TextCard
                        image={tfIn_Icon}
                        isLoading={isDataLoad}
                        showCount={true}
                        subtitle={checkValue(data?.amount_inr)}
                        title={"Total IPO Size in (INR Cr)"}
                    />
                    <TextCard
                        image={tfs_Icon}
                        isLoading={isDataLoad}
                        showCount={true}
                        subtitle={checkValue(data?.num_companies)}
                        title={"No. of Companies"}
                    />
                    <TextCard
                        image={pe_Icon}
                        isLoading={isDataLoad}
                        showCount={true}
                        subtitle={checkValue(data?.num_deals)}
                        title={"No. of Deals"}
                    />

                    </div>
                </div>
                <div className='border-b-2 border-[#e5e5e5]'></div>
            </div >
        </div >
    )
}



export default IpoCard